import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    // MSAL redirects here after login; redirect handling runs in the app initializer,
    // then we hand off to the login route which completes the JWT exchange.
    path: 'msal',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/routes').then((r) => r.authRoutes),
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/errors/routes').then((r) => r.errorsRoutes),
  },
  {
    path: '',
    loadChildren: () => import('./modules/routes').then((r) => r.modulesRoutes),
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
